var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 284,
    viewBox: "0 0 553 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.8749,
    y: 22.3872,
    width: 389.399,
    height: 129.44,
    rx: 11.5,
    transform: "rotate(2.09999 89.8749 22.3872)",
    fill: "white",
    stroke: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104.686,
    y: 35.4778,
    width: 95.345,
    height: 104.508,
    rx: 8,
    transform: "rotate(1.96198 104.686 35.4778)",
    fill: "#F1F1F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.807,
    y: 39.0897,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(1.66066 207.807 39.0897)",
    fill: "#F1F1F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 391.506,
    y: 43.163,
    width: 63.4327,
    height: 25.3951,
    rx: 5,
    transform: "rotate(1.66066 391.506 43.163)",
    fill: "#F1F1F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 206.426,
    y: 81.6641,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(1.66066 206.426 81.6641)",
    fill: "#E5E5E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 206.329,
    y: 124.358,
    width: 176.207,
    height: 18.7911,
    rx: 5,
    transform: "rotate(1.66066 206.329 124.358)",
    fill: "#E5E5E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 150.768,
    y: 37.6074,
    width: 395.083,
    height: 174.098,
    rx: 11.5,
    transform: "rotate(7.42517 150.768 37.6074)",
    fill: "white",
    stroke: "#E5E5E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164.3,
    y: 52.016,
    width: 95.345,
    height: 104.508,
    rx: 8,
    transform: "rotate(7.28717 164.3 52.016)",
    fill: "#F1F1F1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 266.64,
    y: 65.1829,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(6.98584 266.64 65.1829)",
    fill: "#F1F1F1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 449.169,
    y: 86.2874,
    width: 63.4326,
    height: 25.3951,
    rx: 5,
    transform: "rotate(6.98584 449.169 86.2874)",
    fill: "#F1F1F1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 261.315,
    y: 107.445,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(6.98584 261.315 107.445)",
    fill: "#E5E5E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 257.255,
    y: 149.946,
    width: 176.207,
    height: 18.7911,
    rx: 5,
    transform: "rotate(6.98584 257.255 149.946)",
    fill: "#E5E5E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.527338,
    y: 95.8765,
    width: 389.399,
    height: 129.44,
    rx: 11.5,
    transform: "rotate(-3.22519 0.527338 95.8765)",
    fill: "white",
    stroke: "#E5E5E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4893,
    y: 107.536,
    width: 95.345,
    height: 104.508,
    rx: 8,
    transform: "rotate(-3.3632 16.4893 107.536)",
    fill: "#F1F1F1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 119.5,
    y: 101.562,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(-3.66452 119.5 101.562)",
    fill: "#F1F1F1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 302.785,
    y: 88.5689,
    width: 63.4327,
    height: 25.3951,
    rx: 5,
    transform: "rotate(-3.66452 302.785 88.5689)",
    fill: "#F1F1F1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 122.077,
    y: 144.081,
    width: 176.207,
    height: 35.5338,
    rx: 5,
    transform: "rotate(-3.66452 122.077 144.081)",
    fill: "#E5E5E5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 125.942,
    y: 186.599,
    width: 176.207,
    height: 18.7911,
    rx: 5,
    transform: "rotate(-3.66452 125.942 186.599)",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/no-record.303a543ac8aa5586380db5a0a2b16395.svg";
export { ForwardRef as ReactComponent };